import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import thumbsUp from '../../assets/icons/thumbs-up.svg'
import thumbsUpPrint from '../../assets/icons/thumbs-up-print.svg'
import thumbsDown from '../../assets/icons/thumbs-down.svg'
import thumbsDownPrint from '../../assets/icons/thumbs-down-print.svg'
import './ReviewEntry.sass'


class ReviewEntry extends Component {
  state = {
    isExpanded: false
  }

  constructor() {
    super()
    this._expand = this.expand.bind(this)
  }

  expand() {
    this.setState({ isExpanded: true })
  }

  renderTextBlock(text, isExpanded) {
    const truncatedText = _.truncate(text, { length: 350 })
    const isMoreText = truncatedText !== text

    // If there's more text left to display after trunction, and it's not already expanded, show truncated text + expand button
    return (
      <div>
        <p className="review-text-print">{text}</p>
        <p className="review-text">{!isExpanded && isMoreText ? truncatedText : text}</p>
        { (!isExpanded && isMoreText) &&
          <button type="button" onClick={this._expand}>Read more...</button>
        }
      </div>
    )
  }

  render() {
    const { isExpanded } = this.state
    const { review } = this.props

    return (
      <div className="review-entry">
        <img
          src={review.rating === 'upvote' ? thumbsUp : thumbsDown}
          alt={`thumbs ${review.rating === 'upvote' ? 'thumbs up' : 'thumbs down'}`}
          className="review-icon"
        />
        <img
          className="review-icon-print"
          src={review.isUpvote ? thumbsUpPrint : thumbsDownPrint}
          alt={review.isUpvote ? 'thumbs up' : 'thumbs down'}
        />
        {this.renderTextBlock(review.text, isExpanded)}
        <p className="review-author">by {review.author}</p>
      </div>
    )
  }
}

ReviewEntry.propTypes = {
  review: PropTypes.object
}

export default ReviewEntry
